import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListarGruposAtivosController } from "../../../../Controllers/Geral/Grupos/GruposController";
import MultSelect from "../../../../Components/CardsPages/Forms/MultSelect";
import { FilterFormDataInterface } from "../useGestaoAcordosCobranca";
import {
    IEmpreendimento,
    IUnidade,
} from "../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import { UsuarioInterface } from "../../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";
import { Dispatch, SetStateAction } from "react";

interface IFiltroGestaoAcordos {
    handleDateChange: (formData: FilterFormDataInterface) => void;
    register: any;
    control: any;
    handleSubmit: any;
    reset: any;
    lstUnidades: Array<IUnidade>;
    lstUsuarios: Array<UsuarioInterface>;
    filter: FilterFormDataInterface;
    setFilter: Dispatch<SetStateAction<FilterFormDataInterface>>;
    lstEmpreendimentos: Array<IEmpreendimento>;
    filtroInicial: any;
    handleEmpreendimento: (event: any) => void;
}

export default function FiltroGestaoAcordos(props: IFiltroGestaoAcordos) {
    return (
        <form
            className="form-group row"
            onSubmit={props.handleSubmit(props.handleDateChange)}
        >
            <div className="col-12 mt-3">
                <label>Data Inicial</label>
                <input
                    className="form-control"
                    type="date"
                    defaultValue={props.filter.DATA_INICIO}
                    name="DATA_INICIO"
                    ref={props.register()}
                />
            </div>
            <div className="col-12 mt-3">
                <label>Data Final</label>
                <input
                    className="form-control"
                    type="date"
                    defaultValue={props.filter.DATA_FIM}
                    name="DATA_FIM"
                    ref={props.register()}
                />
            </div>
            <div className="col-12 mt-3">
                <label>Tipo de Filtro</label>
                <select
                    name="ID_TIPO_FILTRO"
                    className={`form-control`}
                    defaultValue={props.filter.ID_TIPO_FILTRO}
                    ref={props.register({
                        valueAsNumber: true,
                    })}
                >
                    <option value={1}>Data de Solicitação </option>
                    <option value={2}>Data de Envio</option>
                    <option value={3}>Data de Vencimento</option>
                    <option value={4}>Data de Recebimento ERP</option>
                </select>
            </div>
            <div className="col-12 mt-3">
                <label>Grupos</label>
                <MultSelect
                    control={props.control}
                    name="ID_GRUPO"
                    defaultValue={props.filter.ID_GRUPO}
                    controller={ListarGruposAtivosController}
                    getDS={(g) => g.DS_GRUPO}
                    getKeyValue={(g) => g.ID_GRUPO}
                />
            </div>
            <div className={`col-12 mt-3`}>
                <label>Cliente</label>
                <input
                    className="form-control"
                    name="DS_NOME_CLIENTE"
                    ref={props.register()}
                />
            </div>
            <div className="col-12 mt-3">
                <label>Empreendimento</label>
                <select
                    className="form-control"
                    name="ID_EMPREENDIMENTO"
                    ref={props.register()}
                    defaultValue={props.filter.ID_EMPREENDIMENTO}
                    onChange={async (event) => {
                        props.handleEmpreendimento(event);
                    }}
                >
                    <option value={0}></option>
                    {props.lstEmpreendimentos.map((empreendimento: any) => (
                        <option
                            key={empreendimento.ID_EMPREENDIMENTO}
                            value={empreendimento.ID_EMPREENDIMENTO}
                        >
                            {empreendimento.DS_EMPREENDIMENTO}
                        </option>
                    ))}
                </select>
            </div>
            <div
                className={`col-12 mt-3 ${
                    props.lstUnidades?.length === 0 ? "d-none" : ""
                }`}
            >
                <label>Unidade</label>
                <select
                    className="form-control"
                    name="ID_UNIDADE"
                    ref={props.register()}
                >
                    <option value={0}></option>
                    {props.lstUnidades?.map((unidade: any) => (
                        <option
                            key={unidade.ID_UNIDADE}
                            value={unidade.ID_UNIDADE}
                        >
                            {unidade.DS_UNIDADE}
                        </option>
                    ))}
                </select>
            </div>
            <div className="col-12 mt-3">
                <label>Usuario Atendimento</label>
                <select
                    className="form-control"
                    name="ID_USUARIO_BUSCA"
                    defaultValue={props.filter.ID_USUARIO_BUSCA}
                    ref={props.register({
                        valueAsNumber: true,
                    })}
                >
                    <option value={0}></option>
                    {props.lstUsuarios &&
                        props.lstUsuarios.map((usuario: any) => (
                            <option
                                value={usuario.ID_USUARIO}
                                key={usuario.ID_USUARIO}
                            >
                                {usuario.DS_NOME}
                            </option>
                        ))}
                </select>
            </div>
            <div className="col-12 mt-3">
                <label>Usuario Solicitante</label>
                <select
                    className="form-control"
                    name="ID_USUARIO_SOLICITANTE"
                    defaultValue={props.filter.ID_USUARIO_SOLICITANTE}
                    ref={props.register({
                        valueAsNumber: true,
                    })}
                >
                    <option value={0}></option>
                    {props.lstUsuarios &&
                        props.lstUsuarios.map((usuario: any) => (
                            <option
                                value={usuario.ID_USUARIO}
                                key={usuario.ID_USUARIO}
                            >
                                {usuario.DS_NOME}
                            </option>
                        ))}
                </select>
            </div>
            <div className="col-12 mt-3">
                <label>Pesquisar por Protocolo</label>
                <input
                    name="ID_CASO"
                    type="number"
                    className={`form-control`}
                    ref={props.register({
                        valueAsNumber: true,
                    })}
                ></input>
            </div>
            <div className="col-12 mt-3 d-flex flex-wrap ">
                <div className="col-6">
                    <div className="d-flex align-items-center justify-content-center">
                        <span>Não Quitados</span>
                    </div>
                    <span
                        className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                        data-toggle="tooltip"
                    >
                        <label>
                            <input
                                name="FL_BOLETOS_NAO_QUITADOS"
                                type="checkbox"
                                ref={props.register()}
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
                <div className="col-6">
                    <div className="d-flex align-items-center justify-content-center">
                        <span>Quitados</span>
                    </div>
                    <span
                        className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                        data-toggle="tooltip"
                    >
                        <label>
                            <input
                                name="FL_BOLETOS_QUITADOS"
                                type="checkbox"
                                ref={props.register()}
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
            </div>
            <div className="col-12 col-md-12 d-flex align-items-end justify-content-start">
                <button
                    type="submit"
                    className="btn btn-block btn-outline-dark mt-2"
                >
                    <FontAwesomeIcon icon={faFilter} className="mr-2" />
                    Filtrar
                </button>
            </div>
            <div className="col-12 d-flex align-items-end justify-content-start">
                <button
                    type="button"
                    onClick={() => {
                        window.sessionStorage.removeItem(
                            "FILTRO_GESTAO_ACORDOS_COBRANCA"
                        );
                        props.setFilter(props.filtroInicial);
                        props.reset(props.filtroInicial);
                    }}
                    className="btn btn-block btn-outline-danger mt-2"
                >
                    <FontAwesomeIcon icon={faTimes} className="mr-2" />
                    Limpar Filtros
                </button>
            </div>
        </form>
    );
}
